<template>
  <div ref="accent">
    <tree-menu-item-accent v-if="shouldRender" />
  </div>
</template>
<script setup lang="ts">
import type { WorkflowOverviewItemType } from '@app/application/workflow-overview-navigation/types'

import { storeToRefs } from 'pinia'
import { computed, ref, watchEffect } from 'vue'

import TreeMenuItemAccent from '@app/shared/vue/components/menu/tree/tree-menu-accent.vue'

import { useWorfklowReviewItems } from '@app/application/workflows/screens/workflow-review/store/pinia/workflow-review-items'

interface Props {
  itemId: number
  itemType: WorkflowOverviewItemType
  highlightedId?: number
  highlightedType?: WorkflowOverviewItemType | ''
  scrollIntoViewTimestamp?: number
}

const props = withDefaults(defineProps<Props>(), {
  highlightedId: 0,
  highlightedType: '',
  scrollIntoViewTimestamp: 0,
})

const emit =
  defineEmits<{
    scrollOffsetElement: [value: HTMLElement]
  }>()

const reviewItemsStore = useWorfklowReviewItems()

const { currentReviewItem } = storeToRefs(reviewItemsStore)

const accent = ref<HTMLElement | null>(null)
const selectedId = ref(props.highlightedId ? props.highlightedId : 0)
const selectedType = ref(props.highlightedType ? props.highlightedType : '')

const shouldRender = computed(() => {
  return (
    props.itemId === selectedId.value && props.itemType === selectedType.value
  )
})

watchEffect(() => {
  if (shouldRender.value && accent.value && props.scrollIntoViewTimestamp) {
    emit('scrollOffsetElement', accent.value)
  }
})

// If not set to a specific item, get the current review item from the store
watchEffect(() => {
  if (
    currentReviewItem.value &&
    !props.highlightedId &&
    !props.highlightedType &&
    (currentReviewItem.value.id !== selectedId.value ||
      currentReviewItem.value.itemClass !== selectedType.value)
  ) {
    selectedId.value = currentReviewItem.value.id
    selectedType.value = currentReviewItem.value.itemClass
  }
})
</script>
